/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/** Translation keys for the PickupInfoComponent */
export const pickupInfo = {
  inStorePickup: 'Recogida en tienda',
  pickupBy: 'Recogida por',
  pickupFrom: 'Recogida en',
};

/** Translation keys for the PickupOptionDialogComponent */
export const pickupOptionDialog = {
  close: 'Cerrar',
  modalHeader: 'Recogida en tienda',
};

/** Translation keys for the PickupOptionsComponent */
const pickupOptions = {
  changeStore: 'Cambiar tienda',
  delivery: 'Envío (devolución gratuita)',
  pickup: 'Recogida gratuita en la tienda',
  selectStore: 'Seleccione Tienda',
};

/** Translation keys for the SetPreferredStoreComponent */
export const setPreferredStore = {
  makeThisMyStore: 'Haz de esto mi tienda',
  myStore: 'Mi Tienda',
};

/** Translation keys for the StoreComponent */
export const store = {
  pickupFromHere: 'Recoger desde aquí',
  stockLevel_inStock: '{{ count }} En stock',
  stockLevel_outOfStock: 'Agotado',
  viewHours: 'Ver Horario',
};

/** Translation keys for the StoreListComponent */
export const storeList = {
  noStoresMessage: 'No se han encontrado tiendas en la base de datos...',
};

/** Translation keys for the StoreScheduleComponent */
export const storeSchedule = {
  closed: 'Cerrard',
  storeHours: 'Horario de la tienda',
};

/** Translation keys for the StoreSearchComponent */
export const storeSearch = {
  findAStore: 'Buscar una tienda',
  findStores: 'Buscar tiendas',
  hideOutOfStockOptions: 'Ocultar las opciones sobre acciones',
  searchPlaceholder: 'Ingrese el código postal, la ciudad o la dirección',
  useMyLocation: 'Usar mi ubicación',
};
/** Translation keys for the AddressBook PickupInStoreComponent */

export const addressBookPickupInStore = {
  heading: 'Tienda de recogida',
};

/** Translation keys for Preferred Store on Store Finder Page */

export const storeFinderPickupInStore = {
  heading: 'Mi Tienda',
};

/** Translation keys for Pickup In Store In Checkout */

export const checkoutPickupInStore = {
  heading: 'Artículos a recoger',
  storeArtículoHeading: 'Dirección de la tienda de recogida',
};

export const cartArtículos = {
  item: 'Artículo',
};

export const deliveryPointOfServiceDetails = {
  itemsToBePickUp: 'Artículos To Be Pick-Up',
  pickUpInStoreAddress: 'Dirección de la tienda de recogida',
  itemsToBeShipped: 'Artículos a enviar',
  shippingAddress: 'Dirección de envío',
  deliveryMethod: 'Método de entrega',
  statusDisplay_cancelled: 'Anulado',
  statusDisplay_cancelling: 'Cancelar pendiente',
  statusDisplay_completed: 'Completado',
  statusDisplay_created: 'Creado',
  statusDisplay_error: 'Pendiente',
  statusDisplay_Error: 'Pendiente',
  statusDisplay_processing: 'Pendiente',
  statusDisplay_open: 'Abrir',
  statusDisplay_pending: {
    approval: 'Pendiente Approval',
    merchant: {
      approval: 'Pendiente Merchant Approval',
    },
  },
  statusDisplay_approved: 'Aprobado',
  statusDisplay_rejected: 'Rechazado',
  statusDisplay_merchant: {
    approved: 'Merchant Aprobado',
    rejected: 'Merchant Rechazado',
  },
  statusDisplay_assigned: {
    admin: 'Asignado al administrador',
  },
};

/** All the translation chunks for pickup in store. */
export const pickupInStore = {
  pickupInfo,
  pickupOptionDialog,
  pickupOptions,
  setPreferredStore,
  store,
  storeList,
  storeSchedule,
  storeSearch,
  addressBookPickupInStore,
  storeFinderPickupInStore,
  checkoutPickupInStore,
  cartArtículos,
  deliveryPointOfServiceDetails,
};
